import useLoading from "../../hooks/useLoading";
import ActionButton from "../Button/ActionButton";
import CancelButton from "../Button/CancelButton";
import * as S from "./style";
// icons
import { Warning } from "@phosphor-icons/react";

import apiRequest from "../../hooks/apiRequest";

interface ModalDetailsProps {
  isOpenModal: boolean;
  setModalClose: () => void;
  updateList: () => void;
  endpoint: string;
  data: number[];
  setResponse: (status: number) => void;
}

export default function DeleteAll({
  isOpenModal,
  setModalClose,
  updateList,
  endpoint,
  data,
  setResponse,
}: ModalDetailsProps) {
  const { isLoading, startLoading, stopLoading } = useLoading();

  const handleRightButtonClick = async () => {
    startLoading();
    try {
      const payload = {
        id: data,
      };
      const response = await apiRequest(`${endpoint}`, 'DELETE', payload);
      const status = response.status;
      if (status === 200) {
        setModalClose();
        updateList();
        setResponse(status);
      }
    } catch (error: any) {
      console.error("Erro capturado: ", error);
      if (error.status === 422) {
        alert(error.message); // Exibe os erros de validação no alerta
      } else if (error.status === 403) {
        alert(error.message || "Erro de permissão.");
      } else {
        alert(error.message || "Erro desconhecido.");
      }
    } finally {
      stopLoading();
    }
  };

  if (isOpenModal) {
    return (
      <S.Container>
        <S.Content>
          <S.InfoModel>
            <Warning size={48} weight="fill" />
            <div>
              <h4>Tem certeza que deseja excluir os itens selecionados?</h4>
              <p>Esta ação não poderá ser desfeita.</p>
            </div>
          </S.InfoModel>

          <S.Action>
            <CancelButton name="Cancelar" onClick={setModalClose} />
            <ActionButton
              name={isLoading ? "Excluindo..." : "Confirmar"}
              onClick={handleRightButtonClick}
            />
          </S.Action>
        </S.Content>
      </S.Container>
    );
  }
  return null;
}
